import {Component, inject, OnInit} from '@angular/core'
import {TryAgainComponent} from './try-again/try-again.component'
import {MatCard} from '@angular/material/card'
import {Location} from '@angular/common'

@Component({
  selector: 'spb-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  imports: [
    TryAgainComponent,
    MatCard
  ]
})
export class ErrorComponent implements OnInit {
  /**
   * Error messages
   */
  public errorMessage = ''

  private readonly location = inject(Location)

  public ngOnInit() {
    const state: any = this.location.getState() ?? {}
    this.errorMessage = state.errorMessage
  }

}
